import {useSelector} from 'react-redux'
import {KTCard} from '../../../../_metronic/helpers'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {PartyEditModal} from './party-add-edit/PartyAddEdit'
import {PartysListHeader} from './components/header/PartiesListHeader'
import {PartysTable} from './table/PartiesTable'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import { useState } from 'react'

const PartysList = () => {
  const {itemIdForUpdate} = useListView()
  const cityList = useSelector((state: any) => state.commonList.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isPartyListPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.party_is_list == true
  const [showParty, setShowParty] = useState<boolean>(true)
    document.title = `PANEL | Manage Party`

  return (
    <>
      <KTCard>
        <PartysListHeader showParty={showParty} setShowParty={setShowParty} />
        {isAdmin || true || isPartyListPermission ? <PartysTable showParty={showParty} /> : ''}
      </KTCard>
      {itemIdForUpdate !== undefined && <PartyEditModal />}
    </>
  )
}

const PartysListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PartysList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PartysListWrapper}
